import React from "react";
import { useNavigate } from "react-router-dom";

export default function Section2() {
  const navigate = useNavigate();

  return (
    <div className="w-full Section2 py-[35px]">
      <div className="container-1280 section2-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <div className="w-full md:w-[80%] mx-auto text-center">
          <h1 className="text-[24px] md:text-[34px] font-bold leading-[30px] md:leading-[40px] my-[0.67em] text-[#151515]">
            Mobile App Development Company in UAE That Builds Apps People
            Actually Use
          </h1>

          <div className="text-left leading-[22px] text-[#535353] text-sm md:text-base font-open space-y-4 mb-[20px]">
            <p>
              Whether you have a new app idea, want to improve an existing
              application, or need a complete mobile solution for your
              business, <a href="https://mean3.ae/" className="blue-link">Mean3</a> helps
              companies across UAE build mobile apps that users enjoy using.
            </p>
            <p>
              We are a mobile app development company in Dubai helping
              startups, SMEs, and established businesses create custom iOS,
              Android, and cross-platform applications. From Dubai and Abu
              Dhabi to Sharjah, Ajman, Ras Al Khaimah, Fujairah, Umm Al
              Quwain, and Al Ain, we build apps designed around real business
              needs.
            </p>
            <p>
              Since 2017, our team has worked with 300+ clients. We
              understand what it takes to build an app that performs well,
              passes App Store guidelines, works smoothly on different
              devices, and delivers a better customer experience.
            </p>
            <p>
              Looking for a reliable mobile app development partner in
              Dubai? Talk to Mean3 today and turn your app idea into a
              high-performing digital product.
            </p>
          </div>

          <button
            onClick={() => navigate("/contact-mean3")}
            className="inline-block py-[12px] px-[30px] bg-[#cd2122] rounded-[3px] font-bold text-white border-none leading-[1.15] hover:bg-[#a81a1b] transition-colors"
          >
            Get a Free App Estimate
          </button>
        </div>
      </div>
    </div>
  );
}